import type { OrderStatus } from "@/features/order/types";
import "./OrderStatusCheckboxGroup.css";

export const ORDER_STATUS_FILTER_OPTIONS = [
  { value: "open", label: "Em andamento" },
  { value: "concluido", label: "Concluído" },
  { value: "carregamento", label: "Carregamento" },
  { value: "change_requested", label: "Aguardando alteração" },
  { value: "encerrado", label: "Encerrado" },
  { value: "cancelled", label: "Cancelado" },
] as const satisfies ReadonlyArray<{ value: OrderStatus; label: string }>;

type OrderStatusCheckboxGroupProps = {
  value: OrderStatus[];
  onChange: (statuses: OrderStatus[]) => void;
  ariaLabel?: string;
};

export function OrderStatusCheckboxGroup({
  value,
  onChange,
  ariaLabel = "Status",
}: OrderStatusCheckboxGroupProps) {
  const selectedStatuses = new Set(value);

  function toggleStatus(status: OrderStatus, checked: boolean) {
    const nextStatuses = checked
      ? [...value, status]
      : value.filter((selectedStatus) => selectedStatus !== status);
    onChange(nextStatuses);
  }

  return (
    <div
      aria-label={ariaLabel}
      className="order-status-checkbox-group"
      role="group"
    >
      {ORDER_STATUS_FILTER_OPTIONS.map(({ value: status, label }) => {
        const checked = selectedStatuses.has(status);
        return (
          <label
            key={status}
            className="order-status-checkbox-group__option"
            data-checked={checked ? "true" : undefined}
          >
            <input
              checked={checked}
              type="checkbox"
              onChange={(event) => toggleStatus(status, event.target.checked)}
            />
            <span>{label}</span>
          </label>
        );
      })}
    </div>
  );
}
